module.exports = __webpack_public_path__ + "media/features/form-and-fitness-8fb28d5d.jpg";